import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import Tooltip from 'components/tooltip';

import './styles.scss';

export default function InfoTableTooltip({ children, link, rows, target = '_blank', title }) {
  let label = <a className="clickable">{title}</a>;

  if (link) {
    label = <a href={link} rel="noopener noreferrer" target={target}>{title}</a>;
  }

  if (children) {
    link = children;
  }

  const tooltipContent = (
    <div>
      <label className="form-label m-2">{title}</label>
      <table>
        <tbody>
          {rows.map((row, i) => (
            <tr className={classNames('text-nowrap', { 'border-top': i === 0 })} key={i}>
              <td>{row.label}</td>
              <td>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  if (rows.length) {
    return (
      <Tooltip
        content={tooltipContent}
        overlayClassName="info-table-tooltip"
        placement="bottom"
      >
        {label}
      </Tooltip>
    );
  } else {
    return label;
  }
}

InfoTableTooltip.propTypes = {
  children: PropTypes.node,
  link: PropTypes.string,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node.isRequired,
    })
  ).isRequired,
  target: PropTypes.string,
  title: PropTypes.string.isRequired
};
